
namespace Riepiloghi.Negozio {
    export class RiepiloghiColumns {
        static columnsKey = 'Negozio.Riepiloghi';
    }
}